import { Decoration_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const spoilerConverter = {
  fromPm: {
    type: Decoration_Type.SPOILER,
    convert: () => {
      return [{ type: Decoration_Type.SPOILER }];
    }
  },
  toPm: {
    type: Decoration_Type.SPOILER,
    convert: () => {
      return { type: Decoration_Type.SPOILER };
    }
  }
};
export {
  spoilerConverter
};
//# sourceMappingURL=spoiler-converter.js.map
